import { api } from '@/api'
import type { ApiResponse } from '@/api/typings/response.typing'

export interface InactiveDiscountResponse {
  data: null
  meta: {
    message: string
    errors: string[]
  }
}

export function inactiveDiscountAction(discountId: string): Promise<ApiResponse<InactiveDiscountResponse>> {
  return api.put<ApiResponse<InactiveDiscountResponse>>(`discounts/${discountId}/deactivate`)
}
